module.exports = __webpack_public_path__ + "img/map-location-xl-en.b8b962cf.jpg";